import { getLocalizedStrings } from '../profileSettingsLocalizedStrings';
import classes from './notificationSettings.scss'; 
import overlayClasses from './sceOverlayStyle.scss';
//import ModalPopup from './Presentational/ModalPopup';
import VoicePreferences from './Presentational/ViewAllVoicePreferences';
import TextBox from "./Presentational/addVoiceTextBox";
import NotificationTextSettings from './notificationTextSettingsContainer';
import NotificationVoiceSettings from './notificationVoiceSettingsContainer';
import SceButton from '../../Common/CommonComponents/sceButton';
import FocusTrap from  'focus-trap-react';


class ViewAllVoice  extends React.Component{

    constructor(props) {
        super(props);
        this.strings = getLocalizedStrings('NotificationSettings');
        this.state = {
      preferenceError:[],
      removeVoicePressed:false,voiceErr:false, lastEAPreference:false,
      removeVoice:'',phoneNo:'',isError:false,
      editButtonPress:false,editVoice:"",
      addIconPress:false,enteredVoice:"",
      voiceExistErrMsg:"",cancelButtonPress:false,
      addVoiceExistErrMsg:"",encEditVoiceValue:"",seqNo:null,voice:[],addressGuid:'',doneEnableVoice:true,
      removeButtonPress:false,modifyVoiceError:"",newEditVoice:"",voicePrefErr:false,disabledAdd:true,isVoiceInvalid:false,
      inputVoice:"",isNewVoiceValid:"",addCancelButtonPress:false, validationType:"phone",maxInputLength:13,disabledVoice:"", duplicatePhoneList: new Map(),
      radioButton: { phoneType:'', outlineStyle: '', validStyle: '', labels: [this.strings.mobileRadio, this.strings.landlineRadio]},    
        };
        this.emailIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_MailOn.svg';
        this.addIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Action_Add.svg';
        this.removeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Action_Remove.svg';
        this.editIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/editIcon.svg';
        this.textIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_TextOn.svg';
        this.voiceIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_PhoneOn.svg';
        this.closeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
        this.mainBpNumber='';
        this.CACTCount='';
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
      }
      componentWillMount(){
        if(app.appService.isAuthenticated() || app.appService.isCpcGuestUser()){
          let accountData = app.appService.getUserInfo().profileData.accountData;
          let isValidBPNumber = !_.isEmpty(accountData);
          this.mainBpNumber = (isValidBPNumber && accountData.mainBusinessPartner!==null) ? accountData.mainBusinessPartner.businessPartnerNumber : this.props.bpNumber;
         //this.CACTCount =app.appService.getSessionstorage(app.appUtil.getAppConstants().CACTCountSessionData);
          app.profileSettingsService.getNotificationDetails(this.mainBpNumber).then((response) => {
            if (response.errorCode !== undefined && response.errorCode !== '') {
              this.setState({emailIds: '' });
            }
            else{
             
              let list = response.phoneNumbers.filter(record => record.indicatorSmsEnabled === 'X');
              this.CACTCount=response.contractAccountCount;
             
              this.setState({text :list,emailIds: response.emailAddresses,voice: response.phoneNumbers,addressGuid:response.addressGuid, count:response.phoneNumbers.length, duplicatePhoneList: response.duplicatePhoneList });
             
            }
          });
        }
      }
      componentDidMount() { document.addEventListener('mousedown', this.handleClickOutside); }
      componentWillUnmount() {document.removeEventListener('mousedown', this.handleClickOutside); }
        setWrapperRef(node) {
        this.wrapperRef = node;
       }
       handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
        this.props.cancelViewAllVoiceButtonHandler();
        }
      } 
      getEnrollDetails(bpNumber,encryptedvalue){
        app.profileSettingsService.getEnrollDetails(bpNumber,encryptedvalue,"PHONE").then((response) => {
          if (response.errorCode !== undefined && response.errorCode !== '') {
            //err
          } else {
            this.setPreference(response.impactedDevice, response.lastEAPreference);//impactedpreferences
       if(this.state.preferenceError.length>0 && this.state.removeVoice){
        
              this.setState({voiceErr:true}) ;}
          if(this.state.preferenceError.length>0 && this.state.encEditVoiceValue){
        
              this.setState({voicePrefErr:true}) ;}
     
      } });
  
  }
    setPreference(preferences, lastEAPreference) {
    const updatedState = { ...this.state };
    updatedState.preferenceError = [];
    updatedState.lastEAPreference = lastEAPreference;
    if(lastEAPreference && this.state.removeVoice){
      updatedState.preferenceError.push('Emergency Alerts');
    }
    else{
    preferences.map((preference) => {
      if (preference.category === 'DEMR' && preference.messageType === 'CPP1') {
        updatedState.preferenceError.push('Critical Peak Pricing Notifications');//string to preference
      } else if (preference.category === 'PROG' && preference.messageType === 'BUDA') {
        updatedState.preferenceError.push('Budget Assistance Notifications');
      } else if (preference.category === 'OUTG' && preference.messageType === 'OUTG') {
        updatedState.preferenceError.push('Repair and Maintenance Alerts');
      }
      else if (preference.category === 'OUTG' && preference.messageType === 'EMRG') {
      updatedState.preferenceError.push('Emergency Alerts');
      }
    });
  }
    updatedState.preferenceError = [...new Set(updatedState.preferenceError)];
    this.setState(updatedState);
  }
     
      removeHandler(e,encryptedvalue){
        const updatedState={...this.state};
        updatedState.voiceErr=false;
        updatedState.removeVoicePressed=true;
        updatedState.addIconPress=false;
        updatedState.editButtonPress=false;
        updatedState.removeVoice=encryptedvalue;
        updatedState.doneEnableVoice=false;
        this.getEnrollDetails(this.mainBpNumber,encryptedvalue);
        this.setState(updatedState);
      }
      //used for clicking on cancel
      removeCancelHandler(){
        const updatedState={...this.state};
        updatedState.removeVoicePressed=false;
        updatedState.doneEnableVoice=true;
        this.setState(updatedState);
      }
      //Delete button click functionality
      deleteButtonHandler(e,sn){
       
        let reqObj={ 'deviceType':'voice','addressGuid':this.state.addressGuid,'modifiedValue': this.state.removeVoice,
          'sequenceNumber': sn};
        app.profileSettingsService.modifyCustomerPreference(this.mainBpNumber, reqObj, null, true).then(response => {
          if (response.errorCode && response.errorCode !== ''){
            this.setState({modifyVoiceError: true});
          }else if(this.state.duplicatePhoneList.has(sn)) {
            let duplicateNumber = this.state.duplicatePhoneList.get(sn);
            reqObj = { 'deviceType':'voice','addressGuid':this.state.addressGuid,'modifiedValue': duplicateNumber.encryptedvalue,
            'sequenceNumber': duplicateNumber.sequenceNumber};
            app.profileSettingsService.modifyCustomerPreference(this.props.bpNumber, reqObj, null, true).then(response => {              
            this.refreshNotification();
            const updatedState = { ...this.state };
            updatedState.removeVoicePressed=false;
            updatedState.doneEnableVoice=true;
            updatedState.modifyVoiceError=false;
            this.setState(updatedState);
            });
          } else {
            this.refreshNotification();
            const updatedState = { ...this.state };
            updatedState.removeVoicePressed=false;
            updatedState.doneEnableVoice=true;
            updatedState.modifyVoiceError=false;
            this.setState(updatedState);
          }
        });
      }
      editHandler(e,text,record){
        /* Sonar Cube fix 
          Done by : Keerthi VL
          Date : 23-01-2023
      */
        const updatedState = { ...this.state };
        updatedState.editButtonPress = true, 
        updatedState.editVoice=text; 
        updatedState.encEditVoiceValue=record.encryptedvalue;
        updatedState.seqNo=record.sequenceNumber;
        updatedState.textPreferenceIndicator=record.indicatorSmsEnabled;
        updatedState.voiceExistErrMsg="";
        updatedState.modifyVoiceError=false;
        updatedState.isVoiceInvalid=false;
        updatedState.newEditVoice="";
        updatedState.voicePrefErr=false;
        updatedState.doneEnableVoice=false;
        updatedState.removeVoicePressed=false;
        updatedState.radioButton.phoneType = this.props.isLandlineOrMobile(record.indicatorTelephone,false); 
         this.setState(updatedState);
        this.getEnrollDetails(this.mainBpNumber,record.encryptedvalue);
        
    }
    cancelButtonHandler = () => {
      const updatedState = { ...this.state };
      updatedState.cancelButtonPress = true;
      updatedState.editButtonPress = false;
      updatedState.voiceExistErrMsg="";
      updatedState.doneEnableVoice=true;
      this.setState(updatedState);
      
    }
    voiceCallback(voiceValue){
      const updatedState = { ...this.state };
      updatedState.enteredVoice=voiceValue;
      updatedState.voiceExistErrMsg="";
      this.setState(updatedState,
      ()=>{this.isValidatedVoice(this.state.enteredVoice);});
    }
    isValidatedVoice(ph){
      if(ph.length===12){
       const updatedState = { ...this.state };
       updatedState.disabledVoice=false;
        this.setState(updatedState);
    
      }
      else{
         const updatedState = { ...this.state };
         updatedState.disabledVoice=true;
        this.setState(updatedState);
      }
    
    }
    
    ifPhoneNoExists(phoneNo) {
     
      let phoneExist=false;
      _.each(this.state.voice, function (record) {
        if (record.encryptedvalue === phoneNo)
          phoneExist=true;});
        return phoneExist;
      }
    
    
    saveButtonHandler(){ 
    const updatedState={...this.state};
    if(this.state.enteredVoice!==""){
    let text=this.state.enteredVoice;
    let enteredValue = text.split("-").join("");
      app.profileSettingsService.getEncryptedPhoneNumber(enteredValue).then(response=>{  
        if(!this.ifPhoneNoExists(response.phoneNumber)) {
        updatedState.modifyVoiceError=false,updatedState.editButtonPress = false,updatedState.addIconPress=false,updatedState.newEditVoice=this.state.enteredVoice,updatedState.enteredVoice="",updatedState.voiceExistErrMsg="", updatedState.doneEnableVoice=true,this.setState(updatedState);
        this.props.verifyHandler(app.appUtil.maskPhoneNumberWithhyphenX(this.state.newEditVoice),'ViewAllPhone','U',response.phoneNumber, this.state.seqNo,this.state.radioButton.phoneType);
        }else{
         this.setState({voiceExistErrMsg:this.strings.textExistMsg});       
        }});   
    }
    else{
      this.setState({voiceExistErrMsg:this.strings.textExistMsg});    
     }     
    }
      refreshNotification(){
        app.profileSettingsService.getNotificationDetails(this.mainBpNumber).then((response) => {
          if (response.errorCode !== undefined && response.errorCode !== '') {
            this.setState({emailIds: '' });
          }
          else{
            let list = response.phoneNumbers.filter(record => record.indicatorSmsEnabled === 'X');
            this.setState({text :list,emailIds: response.emailAddresses,voice: response.phoneNumbers,addressGuid:response.addressGuid,count:response.phoneNumbers.length});
          }
        });
      }
    doneViewAllVoiceButtonHandler(){
        this.props.cancelViewAllVoiceButtonHandler();
      }
      phoneTypeHandler = (event) => {
        const updatedState = { ...this.state };
        updatedState.radioButton.phoneType = event.currentTarget.value;
        this.setState(updatedState);
      }
  render(){
    
  return (
    <FocusTrap
    focusTrapOptions={{
      allowOutsideClick: true,
  }}

    >
    <div>
        <div tabIndex="0" className={[overlayClasses.sceOverlay, classes.sceSetNotificationsDialog].join(' ')}>
    <div className={overlayClasses.sceOverlayContent}>
        <div   ref={this.setWrapperRef} className={overlayClasses.sceDialogBox}>
            <div className='row'>

                <div className={'col-xs-12 ' + classes.sceSetNotificationMainHeader}>{this.strings.viewAllPhoneTitle} {'('}{this.state.count}{')'}

                <button className={classes.sceImageCloseButton} onClick={this.props.cancelViewAllVoiceButtonHandler} aria-label="Close icon" > <img className={classes.iconClose} src={this.closeIcon} id={"closeIcon"} alt="Close Icon" /></button>
                </div>
            </div>
            <div className={classes.viewAllScrollableContent}>
            <VoicePreferences isLandlineOrMobile={this.props.isLandlineOrMobile}  radioButton={this.state.radioButton}  phoneTypeHandler={this.phoneTypeHandler} verificationSuccessful={this.state.verificationSuccessful} verifyHandler={this.props.verifyHandler} type={this.state.validationType} maxLength={this.state.maxInputLength} preferenceDetails={this.state.preferenceDetails} editHandler={this.editHandler.bind(this)} editButton={this.state.editButtonPress} editVoice={this.state.editVoice} 
            newText={this.state.newEditVoice} voiceCallback={this.voiceCallback.bind(this)} cancelButtonHandler={this.cancelButtonHandler.bind(this)} saveButtonHandler={this.saveButtonHandler.bind(this)} voiceExistErrMsg={this.state.voiceExistErrMsg} modifyVoiceError={this.state.modifyVoiceError}
               data={this.state} CACTCount={this.CACTCount} voiceData={this.state} removeHandler={this.removeHandler.bind(this)} removeCancelHandler={this.removeCancelHandler.bind(this)} deleteButtonHandler={this.deleteButtonHandler.bind(this)}
               voicePrefErr={this.state.voicePrefErr} encEditVoiceValue={this.state.encEditVoiceValue} placeHolder={!_.isEmpty(this.state.editVoice) ? this.state.editVoice : 'Enter Phone'} disabledVoice={this.state.disabledVoice} /> 
            </div>
            

            <div className="text-align-center">

                <div className={classes.footerButton}>
                    <div className={classes.turnOnBtn}>
                    {this.state.doneEnableVoice ?  

                        <SceButton
                            buttonType="primary"
                            value="Done"
                            onClick={this.doneViewAllVoiceButtonHandler.bind(this)}
                        />
                        :
                        <SceButton
                        buttonType="sceDisabled"
                        value="Done"
                        onClick={this.doneViewAllVoiceButtonHandler.bind(this)}
                    />
                    }



                    </div>
                </div>

            </div>
        </div>
    </div>
</div>





</div>    
</FocusTrap>
     );}
}
export default ViewAllVoice;